/* Canales gratuitos: listas públicas de emisiones en abierto que se añaden con un toque. Son
   listas M3U como cualquier otra; aquí solo se guarda dónde están. Las mantienen terceros:
   pueden cambiar de dirección o dejar de publicarse, y algunos canales solo se ven desde su país. */

export const PRESETS = [
    {
        id: 'archive',
        name: 'Cine clásico',
        provider: 'archive', // no es una lista M3U: se guarda como un proveedor propio (core/archive.js)
        m3uUrl: '',
        epgUrl: '',
        icon: 'theaters',
        source: 'Internet Archive'
    },
    {
        id: 'tdt-tv',
        name: 'TDT en abierto',
        m3uUrl: 'https://www.tdtchannels.com/lists/tv.m3u8',
        epgUrl: 'https://www.tdtchannels.com/epg/TV.xml.gz',
        icon: 'tv',
        source: 'TDTChannels'
    },
    {
        id: 'tdt-radio',
        name: 'Radio en abierto',
        m3uUrl: 'https://www.tdtchannels.com/lists/radio.m3u8',
        epgUrl: '',
        icon: 'radio',
        source: 'TDTChannels'
    },
    {
        id: 'iptv-org-es',
        name: 'Canales públicos de España',
        m3uUrl: 'https://iptv-org.github.io/iptv/countries/es.m3u',
        epgUrl: '',
        icon: 'public',
        source: 'iptv-org'
    }
];

/* Listas públicas por país de iptv-org (https://github.com/iptv-org/iptv): una por país, con las emisiones en
   abierto que hay en su directorio. [código de iptv-org, nombre en inglés]; el nombre en el idioma de la
   interfaz sale de Intl.DisplayNames y este solo sirve de respaldo. Solo están los países que hoy tienen canales. */
export const COUNTRY_LISTS = [
    ['af', 'Afghanistan'],
    ['al', 'Albania'],
    ['dz', 'Algeria'],
    ['ad', 'Andorra'],
    ['ao', 'Angola'],
    ['ag', 'Antigua and Barbuda'],
    ['ar', 'Argentina'],
    ['am', 'Armenia'],
    ['aw', 'Aruba'],
    ['au', 'Australia'],
    ['at', 'Austria'],
    ['az', 'Azerbaijan'],
    ['bs', 'Bahamas'],
    ['bh', 'Bahrain'],
    ['bd', 'Bangladesh'],
    ['bb', 'Barbados'],
    ['by', 'Belarus'],
    ['be', 'Belgium'],
    ['bz', 'Belize'],
    ['bj', 'Benin'],
    ['bt', 'Bhutan'],
    ['bo', 'Bolivia'],
    ['bq', 'Bonaire'],
    ['ba', 'Bosnia and Herzegovina'],
    ['br', 'Brazil'],
    ['vg', 'British Virgin Islands'],
    ['bn', 'Brunei'],
    ['bg', 'Bulgaria'],
    ['bf', 'Burkina Faso'],
    ['kh', 'Cambodia'],
    ['cm', 'Cameroon'],
    ['ca', 'Canada'],
    ['cv', 'Cape Verde'],
    ['td', 'Chad'],
    ['cl', 'Chile'],
    ['cn', 'China'],
    ['co', 'Colombia'],
    ['km', 'Comoros'],
    ['cr', 'Costa Rica'],
    ['hr', 'Croatia'],
    ['cu', 'Cuba'],
    ['cw', 'Curacao'],
    ['cy', 'Cyprus'],
    ['cz', 'Czech Republic'],
    ['cd', 'Democratic Republic of the Congo'],
    ['dk', 'Denmark'],
    ['do', 'Dominican Republic'],
    ['ec', 'Ecuador'],
    ['eg', 'Egypt'],
    ['sv', 'El Salvador'],
    ['gq', 'Equatorial Guinea'],
    ['er', 'Eritrea'],
    ['ee', 'Estonia'],
    ['et', 'Ethiopia'],
    ['fi', 'Finland'],
    ['fr', 'France'],
    ['gf', 'French Guiana'],
    ['pf', 'French Polynesia'],
    ['gm', 'Gambia'],
    ['ge', 'Georgia'],
    ['de', 'Germany'],
    ['gh', 'Ghana'],
    ['gr', 'Greece'],
    ['gp', 'Guadeloupe'],
    ['gu', 'Guam'],
    ['gt', 'Guatemala'],
    ['gg', 'Guernsey'],
    ['gn', 'Guinea'],
    ['gy', 'Guyana'],
    ['ht', 'Haiti'],
    ['hn', 'Honduras'],
    ['hk', 'Hong Kong'],
    ['hu', 'Hungary'],
    ['is', 'Iceland'],
    ['in', 'India'],
    ['id', 'Indonesia'],
    ['ir', 'Iran'],
    ['iq', 'Iraq'],
    ['ie', 'Ireland'],
    ['il', 'Israel'],
    ['it', 'Italy'],
    ['ci', 'Ivory Coast'],
    ['jm', 'Jamaica'],
    ['jp', 'Japan'],
    ['jo', 'Jordan'],
    ['kz', 'Kazakhstan'],
    ['ke', 'Kenya'],
    ['xk', 'Kosovo'],
    ['kw', 'Kuwait'],
    ['kg', 'Kyrgyzstan'],
    ['la', 'Laos'],
    ['lv', 'Latvia'],
    ['lb', 'Lebanon'],
    ['ly', 'Libya'],
    ['li', 'Liechtenstein'],
    ['lt', 'Lithuania'],
    ['lu', 'Luxembourg'],
    ['mo', 'Macao'],
    ['mg', 'Madagascar'],
    ['my', 'Malaysia'],
    ['mv', 'Maldives'],
    ['ml', 'Mali'],
    ['mt', 'Malta'],
    ['mq', 'Martinique'],
    ['mr', 'Mauritania'],
    ['mu', 'Mauritius'],
    ['mx', 'Mexico'],
    ['md', 'Moldova'],
    ['mc', 'Monaco'],
    ['mn', 'Mongolia'],
    ['me', 'Montenegro'],
    ['ma', 'Morocco'],
    ['mz', 'Mozambique'],
    ['mm', 'Myanmar'],
    ['na', 'Namibia'],
    ['np', 'Nepal'],
    ['nl', 'Netherlands'],
    ['nz', 'New Zealand'],
    ['ni', 'Nicaragua'],
    ['ne', 'Niger'],
    ['ng', 'Nigeria'],
    ['kp', 'North Korea'],
    ['mk', 'North Macedonia'],
    ['no', 'Norway'],
    ['om', 'Oman'],
    ['pk', 'Pakistan'],
    ['ps', 'Palestine'],
    ['pa', 'Panama'],
    ['pg', 'Papua New Guinea'],
    ['py', 'Paraguay'],
    ['pe', 'Peru'],
    ['ph', 'Philippines'],
    ['pl', 'Poland'],
    ['pt', 'Portugal'],
    ['pr', 'Puerto Rico'],
    ['qa', 'Qatar'],
    ['cg', 'Republic of the Congo'],
    ['re', 'Reunion'],
    ['ro', 'Romania'],
    ['ru', 'Russia'],
    ['rw', 'Rwanda'],
    ['kn', 'Saint Kitts and Nevis'],
    ['lc', 'Saint Lucia'],
    ['vc', 'Saint Vincent and the Grenadines'],
    ['ws', 'Samoa'],
    ['sm', 'San Marino'],
    ['sa', 'Saudi Arabia'],
    ['sn', 'Senegal'],
    ['rs', 'Serbia'],
    ['sl', 'Sierra Leone'],
    ['sg', 'Singapore'],
    ['sx', 'Sint Maarten'],
    ['sk', 'Slovakia'],
    ['si', 'Slovenia'],
    ['so', 'Somalia'],
    ['za', 'South Africa'],
    ['kr', 'South Korea'],
    ['es', 'Spain'],
    ['lk', 'Sri Lanka'],
    ['sd', 'Sudan'],
    ['sr', 'Suriname'],
    ['se', 'Sweden'],
    ['ch', 'Switzerland'],
    ['sy', 'Syria'],
    ['tw', 'Taiwan'],
    ['tj', 'Tajikistan'],
    ['tz', 'Tanzania'],
    ['th', 'Thailand'],
    ['tg', 'Togo'],
    ['tt', 'Trinidad and Tobago'],
    ['tn', 'Tunisia'],
    ['tr', 'Turkiye'],
    ['tm', 'Turkmenistan'],
    ['ug', 'Uganda'],
    ['ua', 'Ukraine'],
    ['ae', 'United Arab Emirates'],
    ['uk', 'United Kingdom'],
    ['us', 'United States'],
    ['uy', 'Uruguay'],
    ['uz', 'Uzbekistan'],
    ['va', 'Vatican City'],
    ['ve', 'Venezuela'],
    ['vn', 'Vietnam'],
    ['eh', 'Western Sahara'],
    ['ye', 'Yemen'],
    ['zw', 'Zimbabwe']
];

const COUNTRY_URL = /^https:\/\/iptv-org\.github\.io\/iptv\/countries\/([a-z]{2})\.m3u$/;

/** Código de región (ISO 3166) de un código de iptv-org: allí el Reino Unido es «uk». */
export function regionOf(code) {
    return code === 'uk' ? 'GB' : String(code).toUpperCase();
}

/** La lista pública de un país, con la misma forma que las de PRESETS; null si no la hay. */
export function countryPreset(code) {
    const c = String(code || '').toLowerCase();
    const known = COUNTRY_LISTS.find((x) => x[0] === c);
    if (!known) return null;
    return { id: 'iptv-org-' + c, name: known[1], m3uUrl: 'https://iptv-org.github.io/iptv/countries/' + c + '.m3u', epgUrl: '', icon: 'public', source: 'iptv-org', country: c };
}

export function presetById(id) {
    const fixed = PRESETS.find((p) => p.id === id);
    if (fixed) return fixed;
    const m = /^iptv-org-([a-z]{2})$/.exec(String(id || ''));
    return m ? countryPreset(m[1]) : null;
}

/** La lista pública a la que corresponde un proveedor guardado, o null si es una lista cualquiera. */
export function presetOf(profile) {
    if (profile && profile.type === 'archive') return PRESETS.find((p) => p.id === 'archive');
    if (!profile || profile.type !== 'm3u') return null;
    const fixed = PRESETS.find((p) => p.m3uUrl === profile.m3uUrl);
    if (fixed) return fixed;
    const m = COUNTRY_URL.exec(String(profile.m3uUrl || ''));
    return m ? countryPreset(m[1]) : null;
}
